import moment from 'moment/moment';

export const formatCurrency = (n) =>
    `$${n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const formatDate = (d) =>
    moment(d).format('MMM D, YYYY');
